export const truncateByWords = (text, maxWords) => {
  if (typeof text !== 'string') return '';
  const words = text.trim().split(/\s+/).filter(Boolean);
  if (words.length <= maxWords) return text;
  return `${words.slice(0, maxWords).join(' ')} ...`;
};

const RTL_ISOLATE_START = '\u2067'; // RLI
const RTL_ISOLATE_END = '\u2069'; // PDI

const isHebrewLocale = (locale) => String(locale || '').trim().toUpperCase() === 'HE';

const wrapRtlIsolate = (text) => {
  if (typeof text !== 'string' || !text) return text || '';
  // Avoid double-wrapping if already isolated.
  if (text.startsWith(RTL_ISOLATE_START) && text.endsWith(RTL_ISOLATE_END)) return text;
  return `${RTL_ISOLATE_START}${text}${RTL_ISOLATE_END}`;
};

export const truncateForTableCell = ({
  text,
  locale,
  maxWordsHe = 10,
  maxWordsEn = 16,
  maxCharsNoSpaces = 140,
}) => {
  const safeText = text || '';
  const isHe = isHebrewLocale(locale);
  const maxWords = isHe ? maxWordsHe : maxWordsEn;

  const byWords = truncateByWords(safeText, maxWords);
  if (byWords !== safeText) {
    return isHe ? wrapRtlIsolate(byWords) : byWords;
  }

  // Fallback for very long strings without spaces
  if (safeText.length > maxCharsNoSpaces) {
    const sliced = `${safeText.slice(0, maxCharsNoSpaces)}...`;
    return isHe ? wrapRtlIsolate(sliced) : sliced;
  }

  return isHe ? wrapRtlIsolate(safeText) : safeText;
};
